import React, {useContext} from 'react'

import SettingsContext from '../components/SettingsContext'
import InfoPanelActions from '../components/InfoPanelActions'

import {
  useRouteNearestTrail,
  useTrailWaypointConnection,
  useStep,
  useWaypoint,
} from '../api'

import {
  CHECK_AVAILABILITY_PRICE,
} from './../trans'


import { useQuadhashActions, useStepActions } from '../hooks'


export const InfoPanelQuadhashActions = (props) => {

  const { quadhash, route_id, trail_id: current_trail_id, isStopPoint, actions: baseActions = [] } = props
  const settings = useContext(SettingsContext)
  const reverse = settings.URLS.reverse
  const { trail_id, distance_from_trail } = useRouteNearestTrail({
    routeId: route_id,
    quadhash: quadhash
  }, { skip: !quadhash }) || {}
  const {
    checkpoint_position, start_length, stop_length,
    start_time, stop_time, step_id=false
  } = useTrailWaypointConnection({
    routeId: route_id,
    trailId: trail_id,
    quadhash: quadhash
  }, { skip: !trail_id || !quadhash }) || {}


  const quadkeyActions = useQuadhashActions({
    current_trail_id: current_trail_id,
    route_id: route_id,
    trail_id: trail_id,
    checkpoint_position: checkpoint_position,
    quadhash: quadhash,
    start_length: start_length,
    stop_length: stop_length,
    distance_from_trail: distance_from_trail,
    isStopPoint: isStopPoint
  }, {skip: !!step_id})

  const step = useStep({
    routeId: route_id,
    trailId: trail_id,
    stepId: step_id
  }, {skip: !step_id})

  const stepAction = useStepActions({
    step: step,
    route_id: route_id,
    trail_id: trail_id,
    current_trail_id: current_trail_id
  },{
    skip: !step
  })

  var actions = stepAction || quadkeyActions || []

  if (!trail_id && !actions && !baseActions) {
    return null
  }

  return <InfoPanelActions actions={ actions ? baseActions.concat(actions) : baseActions} />
}

export default InfoPanelQuadhashActions
